import { render, staticRenderFns } from "./MessageM.vue?vue&type=template&id=6e7f9871&scoped=true"
import script from "./MessageM.vue?vue&type=script&lang=js"
export * from "./MessageM.vue?vue&type=script&lang=js"
import style0 from "./MessageM.vue?vue&type=style&index=0&id=6e7f9871&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7f9871",
  null
  
)

export default component.exports